import {
  Button,
  Divider,
  Grid,
  Stack,
  Typography,
  TextField,
} from "@mui/material";
import { useStyles } from "./styles";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import React from "react";
import ReportChartComponent from "../../../components/ReportChart";
import useReport from "../../../Hooks/report";
import dayjs, { Dayjs } from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { ErrorMessage, Formik } from "formik";
import * as Yup from "yup";
import useAuthStore from "../../../Hooks/auth";
import Loader from "../../../common/Loader";

const ReportSchema = Yup.object().shape({
  from: Yup.string().required("* Please select from year"),
  to: Yup.string().required("* Please select to year"),
});

const Reporting = () => {
  const classes = useStyles();
  const {institutionId}=useAuthStore()
  const [value, setValue] = React.useState("");
  const { reportChartPercentageAction, reportChartPercentageData,loading } =
    useReport();
   console.log(loading,"loading");

  const initValues = {
    from: "",
    to: "",
    institutionId,
  };

  // React.useEffect(() => {
  //   let vv = {
  //     "fromYear":2019,
  //     "toYear":2023
  //   }
  //   reportChartPercentageAction(vv);
  // }, []);

  return (
  <>
    {loading&&<Loader/>}
    <Stack className={classes.root}>
      <Grid container>
        <Grid item md={8} sm={12}>
          <Stack
            sx={{
              // flexDirection: "row",
              // alignItems: "center",
              justifyContent: "space-between",
              maxWidth: "340px",
              p: 2,
              // background: "#F5F5FA",
              // borderRadius: "10px",
              mb: 4,
            }}
          >
            <Stack
              sx={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                display: "flex",
                my: 2,
                gap: 2,
              }}
            >
              <Formik
                validationSchema={ReportSchema}
                initialValues={initValues}
                validateOnBlur={false}
                validateOnChange={false}
                onSubmit={(values) => reportChartPercentageAction(values)}
              >
                {(formik) => {
                  const {
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    values,
                  } = formik;
                  return (
                    <form
                      onSubmit={handleSubmit}
                      className={classes.attendanceForm}
                    >
                      <Stack
                        sx={{
                          flexDirection: "row",
                          alignItems: "center",
                          display: "flex",
                          gap: 1,
                        }}
                      >
                        <Stack>
                          <Typography className={classes.input_label}>
                            From
                          </Typography>
                        </Stack>
                        <Stack>
                          <TextField
                            id="from"
                            type="number"
                            name="from"
                            placeholder="Enter year"
                            sx={{ width: "100%" }}
                            className={
                              errors.from && touched.from
                                ? classes.inputError
                                : classes.inputNoError
                            }
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.from}
                          />
                          <ErrorMessage
                            name="from"
                            component="span"
                            className={classes.error}
                          />
                        </Stack>
                        <Stack
                          sx={{
                            flexDirection: "row",
                            alignItems: "center",
                            display: "flex",
                            gap: 1,
                          }}
                        >
                          <Stack>
                            <Typography className={classes.input_label}>
                              To
                            </Typography>
                          </Stack>
                          <Stack>
                            <TextField
                              id="to"
                              type="number"
                              name="to"
                              placeholder="Enter year"
                              sx={{ width: "100%" }}
                              className={
                                errors.to && touched.to
                                  ? classes.inputError
                                  : classes.inputNoError
                              }
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values.to}
                            />
                            <ErrorMessage
                              name="to"
                              component="span"
                              className={classes.error}
                            />
                          </Stack>
                        </Stack>
                      </Stack>
                      <Button
                        type="submit"
                        sx={{
                          width: "22rem",
                          px: 1,
                          py: 2,
                          borderRadius: "50px",
                          fontSize: "15px",
                        }}
                        className={classes.submit_btn}
                      >
                        Submit
                      </Button>
                    </form>
                  );
                }}
              </Formik>
            </Stack>
          </Stack>
          {/* <Stack
            sx={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              maxWidth: "340px",
              p: 2,
              background: "#F5F5FA",
              borderRadius: "10px",
              mb: 4,
            }}
          >
            <Stack>
              <Typography sx={{ fontWeight: 700 }}>Saved reports</Typography>
              <Typography sx={{ fontSize: "12px", color: "#8083A3" }}>
                Total customers
              </Typography>
            </Stack>
            <Stack
              sx={{
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Button className={classes.download_btn}>
                <ArrowDownwardIcon />
              </Button>
            </Stack>
          </Stack> */}
          {/* <Stack gap={2} mb={4}>
            <Stack
              sx={{ flexDirection: "row", justifyContent: "space-between" }}
            >
              <Stack>
                <Typography>Overal semester report by student</Typography>
              </Stack>
              <Stack sx={{ flexDirection: "row", gap: 4 }}>
                <Typography sx={{ color: "#8083A3" }}>1.350</Typography>
                <Typography>01 Aug 2022</Typography>
              </Stack>
            </Stack>
            <Divider />
            <Stack
              sx={{ flexDirection: "row", justifyContent: "space-between" }}
            >
              <Stack>
                <Typography>Sport Achivement by Year</Typography>
              </Stack>
              <Stack sx={{ flexDirection: "row", gap: 4 }}>
                <Typography>01 Aug 2022</Typography>
              </Stack>
            </Stack>
            <Divider />
            <Stack
              sx={{ flexDirection: "row", justifyContent: "space-between" }}
            >
              <Stack>
                <Typography>Fee Payment Report by semester</Typography>
              </Stack>
              <Stack sx={{ flexDirection: "row", gap: 4 }}>
                <Typography>01 Aug 2022</Typography>
              </Stack>
            </Stack>
            <Divider />
          </Stack> */}
          <Stack id="reportChart">
            <ReportChartComponent />
          </Stack>
        </Grid>
        <Grid item md={4} sm={12}></Grid>
      </Grid>
    </Stack>
  </>
  
  );
};

export default Reporting;
